import { render } from "./MobileNavbar.vue?vue&type=template&id=2dceb74b&scoped=true"
import script from "./MobileNavbar.vue?vue&type=script&lang=js"
export * from "./MobileNavbar.vue?vue&type=script&lang=js"

import "./MobileNavbar.vue?vue&type=style&index=0&id=2dceb74b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dceb74b"]])

export default __exports__